import * as actionTypes from './actionTypes';
import {getColor, getVin} from "../../shared/blackbook";
import Vehicle, {getTrimData} from "../../shared/vehicle";
import {cloneObject} from "../../shared/utility";
import { updateVehicleInList } from './vehicles';

export const setQualifyVehicleData = (data) => {
    return {
        type: actionTypes.SET_QUALIFY_VEHICLE_QUESTIONS,
        data
    };
};

export const resetQualifyVehicle = () => {
    return async (dispatch, getState) => {
        dispatch({data: null, type: actionTypes.RESET_QUALIFY_VEHICLE_QUESTIONS})
    }
}

export const prepareQualifyVehicleQuestions = () => {
    return async (dispatch, getState) => {
        const state = getState()
        const selectedVehicle = cloneObject(state.app.selectedVehicle)
        const qualifyVehicle = cloneObject(state.qualifyVehicle)
        qualifyVehicle.step = 1
        qualifyVehicle.vehicle = {
            ...selectedVehicle
        }
        dispatch(setQualifyVehicleData(qualifyVehicle))
    }
}

export const gatherInfo = (vehicle, cb) => {
    return async (dispatch, getState) => {
        const state = getState()
        const qualifyAppState = cloneObject(state.app.qualifyVehicle)
        const qualifyState = cloneObject(state.qualifyVehicle.vehicle)

        qualifyAppState.loading = true
        dispatch({data: {qualifyVehicle: qualifyAppState}, type: actionTypes.SET_APP_DATA})

        qualifyState.vehicle = cloneObject(vehicle)
        console.log(vehicle)


        const seller = cloneObject(state.account)
        qualifyState.step = 1
        qualifyState.trims = []
        const res = await getVin(qualifyState.vehicle.vin, seller.zip)
        if (res) {
            res.forEach((item, index) => {
                qualifyState.trims.push({
                    ...item
                })
            })
            try {
                const colors = await getColor(qualifyState.vehicle.uvc)
                qualifyState.exteriorColors = colors.exterior
                qualifyState.interiorColors = colors.interior
            } catch (e) {
                qualifyAppState.error = e
            }
        }
        dispatch(setQualifyVehicleData(qualifyState))

        qualifyAppState.loading = false
        dispatch({data: {qualifyVehicle: qualifyAppState}, type: actionTypes.SET_APP_DATA})
        if(cb) cb()
    }
}

export const backQualifyVehicle = () => {
    return async (dispatch, getState) => {
        const state = getState()
        const qualifyVehicle = cloneObject(state.qualifyVehicle)
        qualifyVehicle.step--
        qualifyVehicle.vehicle = qualifyVehicle.vehicle
        dispatch(setQualifyVehicleData(qualifyVehicle))
    }
}


export const saveQuestions = (data) => {
    return async (dispatch, getState) => {
        const state = getState()
        const qualifyAppState = cloneObject(state.app.qualifyVehicle)
        const qualifyState = cloneObject(state.qualifyVehicle)
        const seller = cloneObject(state.account)

        qualifyAppState.loading = true
        qualifyAppState.error = false
        dispatch({data: {qualifyVehicle: qualifyAppState}, type: actionTypes.SET_APP_DATA})


        try {
            let step = qualifyState.step
            let res
            switch (step) {
                case 1:
                    qualifyState.vehicle = {
                        ...qualifyState.vehicle,
                        ...data
                    }

                    qualifyState.vehicle.sellerId = state.account.id

                    res = await getVin(qualifyState.vehicle.vin, seller.zip)
                    qualifyState.trims = []
                    if (res) {
                        res.forEach((item, index) => {
                            qualifyState.trims.push({
                                ...item
                            })
                        })
                        if (qualifyState.trims.length === 1) {
                            const uvc = qualifyState.trims[0].uvc
                            if (uvc) {
                                try {
                                    const colors = await getColor(uvc)
                                    qualifyState.exteriorColors = colors.exterior
                                    qualifyState.interiorColors = colors.interior
                                } catch (e) {
                                    console.log(e)
                                    qualifyAppState.error = e
                                }
                            }
                            qualifyState.vehicle.uvc = uvc
                        }
                    }
                    step = 2
                    break
                case 2:
                    qualifyState.vehicle = {
                        ...qualifyState.vehicle,
                        ...data
                    }
                    step = 3
                    break
                case 3:
                    qualifyState.vehicle = {
                        ...qualifyState.vehicle,
                        ...data
                    }
                    step = 4
                    break
                case 4:
                    const colors = Vehicle.getColorsFromState(qualifyState, data.interiorColor, data.exteriorColor)

                    data.exteriorColor = colors.exteriorColor
                    data.interiorColor = colors.interiorColor

                    const selectedTrim = qualifyState.trims.find((item) => item.uvc === data.uvc)

                    if (!selectedTrim) {
                        throw new Error('Trim not found')
                    }
                    qualifyState.vehicle = {
                        ...qualifyState.vehicle,
                        ...data,
                        ...getTrimData(selectedTrim, state.qualifyVehicle.trims)
                    }

                    step = 5
                    qualifyAppState.loading = true
                    dispatch({data: {qualifyVehicle: qualifyAppState}, type: actionTypes.SET_APP_DATA})
                    dispatch(setQualifyVehicleData({
                        step: step
                    }))
                    break
                case 5:
                    qualifyState.vehicle = {
                        ...qualifyState.vehicle,
                        ...data
                    }
                    qualifyState.vehicle.status = 1


                    const xchange = await Vehicle.save(qualifyState.vehicle);
                    dispatch(updateVehicleInList(xchange));
                    const matchingClients = await Vehicle.getMatchingClients(xchange.id)
                    step = 6
                    qualifyAppState.loading = true
                    dispatch({data: {qualifyVehicle: qualifyAppState}, type: actionTypes.SET_APP_DATA})
                    dispatch(setQualifyVehicleData({
                        step: step,
                        matchingClients
                    }))
                //await getVehicles()

            }
            dispatch({data: {qualifyVehicle: qualifyAppState}, type: actionTypes.SET_APP_DATA})
            dispatch(setQualifyVehicleData({
                vehicle: qualifyState.vehicle,
                trims: qualifyState.trims,
                exteriorColors: qualifyState.exteriorColors,
                interiorColors: qualifyState.interiorColors,
                options: qualifyState.options,
                step: step
            }))
        } catch (e) {
            console.log(e)
            qualifyAppState.error = e.message
        }

        qualifyAppState.loading = false
        dispatch({data: {qualifyVehicle: qualifyAppState}, type: actionTypes.SET_APP_DATA})
    }


}

export const qualifyVehicleResetErrors = () => {
    return async (dispatch, getState) => {
        const state = getState()
        const qualifyAppState = cloneObject(state.app.qualifyVehicle);
        qualifyAppState.error = false
        dispatch({data: {qualifyVehicle: qualifyAppState}, type: actionTypes.SET_APP_DATA})
    }
};